import { render, staticRenderFns } from "./AddThirdParty.vue?vue&type=template&id=93da2c68"
import script from "./AddThirdParty.vue?vue&type=script&lang=js"
export * from "./AddThirdParty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports